// extracted by mini-css-extract-plugin
module.exports =  {"termHeader":"termHeader__tQ1ZW","ranking":"ranking__YGakj"};